<template>
    <div class="containerMap">
        <div style="height:40px;display: flex;flex-direction: row;">
            <el-button type="primary" @click="finish">采集确认</el-button>
            <el-alert title="在地图任意位置右击设置橇装位置" type="info" show-icon></el-alert>
        </div>
        <div style="flex:1">
            <!--地图-->
            <baidu-map class="projMap" :scroll-wheel-zoom="true" :center="center" :zoom="zoom" @ready="renderMap" id="map"
                :key="mapShow" v-if="mapShow">
                <!-- 当前位置-->
                <bm-geolocation anchor="BMAP_ANCHOR_BOTTOM_RIGHT" :showAddressBar="true"
                    :autoLocation="true"></bm-geolocation>
                <!-- 根据关键字搜索位置 -->
                <bm-local-search :keyword="keyword" :auto-viewport="true" :location="location"></bm-local-search>
                <!-- 项目位置 -->
                <bm-marker :position="projPoint" :dragging="true" animation="BMAP_ANIMATION_BOUNCE" v-if="projPointShow">
                    <bm-label :content="centerPointerName" :labelStyle="{ color: 'red', fontSize: '24px' }"
                        :offset="{ width: -40, height: 30 }" :top="true" />
                </bm-marker>



                <!-- <bm-polygon :path="projAreaPoint" stroke-color="blue" :stroke-opacity="0.5" :stroke-weight="2"
                    :editing="true" @lineupdate="updatePolygonPath" v-if="projAreaPointShow" /> -->

                <bm-context-menu>
                    <bm-context-menu-item :callback="setProjPoint" text="设置橇装位置"></bm-context-menu-item>
                    <!-- <bm-context-menu-item :callback="clearProjArea" text="清除项目区域"></bm-context-menu-item> -->
                </bm-context-menu>
            </baidu-map>
        </div>
    </div>
</template>



<script>

export default {
    name: 'Map',
    components: {
        // MapOverlay,
    },
    props: ["address", "value"],
    data() {
        return {
            location: "上海市",
            keyword: "",
            centerPointerName: "请填写橇装地址",

            mapShow: true,
            center: {
                lng: 121.705,
                lat: 31.019
            },
            // 1 ~ 19
            zoom: 19,
            markers: [
                { content: "", windowFlag: false, longitude: 0, latitude: 0 }
            ],
            curMarker: {},
            projPointShow: false,
            projPoint: {},
            projAreaPointShow: false,
            projAreaPoint: [],
        }
    },
    watch: {
        address(n) {
            this.keyword = n;
            this.centerPointerName = n;
        },
    },
    created() {
        if (this.address) {
            this.centerPointerName = this.address;
        }
        if (this.value && this.value.point.lat && this.value.point.lng) {
            let center = { lng: this.value.point.lng, lat: this.value.point.lat };
            this.projPoint = center;
            // this.projAreaPoint = JSON.parse(JSON.stringify(this.value.area));
            this.center = center;
            this.zoom = 19;
            this.projPointShow = true;
            this.projAreaPointShow = true;
        } else if (this.address) {
            this.keyword = this.address;
        }
    },
    mounted() {

    },
    computed: {

    },
    methods: {
        finish() {
            this.$emit("input", { point: this.projPoint, area: this.projAreaPoint })
            this.$emit("changeInfo", { point: this.projPoint, area: this.projAreaPoint })
        },
        setProjPoint: function (e) {
            this.projPoint = e.point;
            this.center = e.point;
            this.projPointShow = true;
            this.setProjArea(e);
        },
        clearProjArea: function () {
            this.projAreaPoint = [];
        },
        setProjArea: function (e) {
            this.clearProjArea();
            this.calculatePolygonPoints(e.point.lat, e.point.lng, 200, 3).forEach(x => {
                this.projAreaPoint.push(x);
            })

            this.projAreaPointShow = true;
        },
        calculatePolygonPoints(centerLat, centerLng, radius, numPoints) {
            const points = [];
            const angleStep = 360 / numPoints;  // 计算每个点之间的角度差

            for (let i = 0; i < numPoints; i++) {
                const angle = (i * angleStep) * (Math.PI / 180);  // 将角度转换为弧度
                const pointLat = centerLat + (radius / 111320) * Math.cos(angle);  // 计算点的纬度
                const pointLng = centerLng + (radius / (111320 * Math.cos(centerLat * (Math.PI / 180)))) * Math.sin(angle);  // 计算点的经度

                points.push({ lat: pointLat, lng: pointLng });
            }
            console.log(points)
            return points;
        },
        renderMap: function ({ BMap, map }) {

            // var map = new BMap.Map("map");
            // map.setMapStyle({
            //     styleId: 'b0a81d0642030825fc2d32ea3cf5acd6'
            // });
            // var cityName = '上海市黄浦区';
            // map.centerAndZoom(cityName, 14); // 初始化地图,设置中心点坐标和地图级别。    map.addControl(new BMap.ScaleControl());                    // 添加比例尺控件
            // map.addControl(new BMap.OverviewMapControl()); //添加缩略地图控件
            // map.enableScrollWheelZoom();
            // //        map.addControl(new BMap.NavigationControl({ type: BMAP_NAVIGATION_CONTROL_LARGE ,anchor: BMAP_ANCHOR_TOP_LEFT, offset: new BMap.Size(40, 250)}));
            // var bdary = new BMap.Boundary();
            // bdary.get(cityName, function (rs) { //获取行政区域
            //     map.clearOverlays(); //清除地图覆盖物

            //     //for循环都删除掉了，只剩下这个
            //     //网上查了下，东西经南北纬的范围
            //     var EN_JW = "180, 90;"; //东北角
            //     var NW_JW = "-180,  90;"; //西北角
            //     var WS_JW = "-180, -90;"; //西南角
            //     var SE_JW = "180, -90;"; //东南角
            //     //4.添加环形遮罩层
            //     var ply1 = new BMap.Polygon(rs.boundaries[0] + SE_JW + SE_JW + WS_JW + NW_JW + EN_JW + SE_JW, {
            //         strokeColor: "none",
            //         fillColor: "rgb(246,246,246)",
            //         fillOpacity: 1,
            //         strokeOpacity: 0.5
            //     }); //建立多边形覆盖物

            //     map.addOverlay(ply1);
            //     //5. 给目标行政区划添加边框，其实就是给目标行政区划添加一个没有填充物的遮罩层
            //     var ply = new BMap.Polygon(rs.boundaries[0], {
            //         strokeWeight: 2,
            //         strokeColor: "#00f",
            //         fillColor: ""
            //     });
            //     map.addOverlay(ply);
            //     //map.setViewport(ply.getPath());    //调整视野
            // });
        },
        updatePolygonPath(e) {
            this.projAreaPoint = e.target.getPath()
        }
    }
}
</script>
<style type="scss">
.containerMap {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
}

.projMap {
    height: 100%;
    width: 100%;

    /* div {
        display: none;
    } */
}

.projMap>div:not(:first-child) {
    display: none;
}
</style>